// src/modules/loading/mutations.js
export function setLoading(state, isLoading) {
    state.isLoading = isLoading;
  }
  